import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import { dateformation } from 'src/components/date-format-mdy';
import InvoiceFollowUpReceiveable from '../invoices-follow-ups';
import { formatCurrency } from '../../../risk-register/feching';

// ----------------------------------------------------------------------

export default function UserTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  serialNumber,
  chartsAccountList,
  bankInformation,
  reload,
}) {
  const {
    customer_id,
    invoice_number,
    invoice_date,
    due_date,
    outstanding_balance,
    total,
    note,
    status,
    project,
    amount_paid,
  } = row;
  const create = useBoolean();
  const confirm = useBoolean();
  const popover = usePopover();

  const remaining_balane = total - amount_paid;

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
        <TableCell>{serialNumber}</TableCell>
        <TableCell style={{ cursor: 'pointer', color: 'blue' }} onClick={create.onTrue}>
          {invoice_number}
        </TableCell>
        <TableCell>{customer_id}</TableCell>
        <TableCell>{project?.name}</TableCell>
        <TableCell>{dateformation(invoice_date) || ' '}</TableCell>
        <TableCell>{dateformation(due_date)}</TableCell>
        <TableCell>{formatCurrency(total)}</TableCell>
        <TableCell>{formatCurrency(amount_paid)}</TableCell>
        <TableCell>{formatCurrency(remaining_balane)}</TableCell>
        <TableCell>{note}</TableCell>
        <TableCell>
          {{
            0: 'Pending',
            1: ' Reviewed',
            2: ' Approved',
            3: ' Submitted',
            4: 'User Accepted',
            5: 'User Rejected',
            6: 'Follow Up',
            7: 'Partially Received',
            8: 'Received Payment',
          }[status] || ''}
        </TableCell>
      </TableRow>
      <InvoiceFollowUpReceiveable
        open={create.value}
        currentItem={row}
        onClose={create.onFalse}
        chartsAccountList={chartsAccountList}
        outstanding_balance={outstanding_balance}
        bankInformation={bankInformation}
        invoice_number={invoice_number}
        reload={reload}
        remaining_balane={remaining_balane}
        amount_paid={amount_paid}
      />
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            onEditRow(row);
            console.log('>>>>>>>', row);
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure you want to delete?"
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              confirm.onFalse();
            }}
          >
            Delete
          </Button>
        }
      />
    </>
  );
}
UserTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
